module.exports = __webpack_public_path__ + "media/images/projects/17-logo-8ae30a7a1de3b99af37b08e8ea17a08b.png";